import React from 'react'
import clsx from 'clsx'
import {
  Check as CheckIcon,
  Clear as ClearIcon,
  Remove as RemoveIcon,
} from '@material-ui/icons'
import {
  Stepper as MuiStepper,
  Step,
  StepConnector,
  StepLabel,
  Typography,
  makeStyles,
  Grid,
  Box,
} from '@material-ui/core'

import styles from './styles'

import useIncidentHighRisk from 'hooks/useIncidentHighRisk'

const useStyles = makeStyles(styles)

const HighRiskStepper = ({ activeStep, children, isDpo }) => {
  const classes = useStyles()
  const { setActiveHighRiskStep: setActiveStep, handleHighRiskStep } =
    useIncidentHighRisk()

  const Icon = (props) => {
    let { icon } = props
    icon -= 1
    const active = icon === activeStep
    const completed = icon < activeStep
    return (
      <Box
        className={clsx(classes.stepIcon, {
          [classes.stepIconActive]: active,
          [classes.stepIconCompleted]: completed,
        })}
      >
        {icon === activeStep ? (
          <RemoveIcon className={classes.iconCheck} />
        ) : icon < activeStep ? (
          <CheckIcon className={classes.iconCheck} />
        ) : (
          <ClearIcon className={classes.iconCheck} />
        )}
      </Box>
    )
  }

  const steps = () => {
    const defaultSteps = ['Larga Escala', 'Critérios Específicos']

    if (isDpo) {
      defaultSteps.splice(2, 0, 'Afetado Significativamente', 'Impacto')
    }

    return defaultSteps
  }

  return (
    <Grid>
      <MuiStepper
        className={classes.stepper}
        activeStep={activeStep}
        nonLinear
        orientation="vertical"
        connector={<StepConnector className={classes.stepConnector} />}
      >
        {steps()?.map((label, index) => {
          let labelProps = {}
          if (activeStep < index) {
            labelProps = (
              <Typography
                variant="caption"
                className={classes.stepLabelTextOptional}
              >
                Responder
              </Typography>
            )
          } else if (activeStep === index) {
            labelProps = (
              <Typography
                variant="caption"
                className={classes.stepLabelTextOptional}
              >
                Respondendo
              </Typography>
            )
          } else {
            labelProps = (
              <Typography
                variant="caption"
                className={classes.stepLabelTextOptional}
              >
                Concluído
              </Typography>
            )
          }

          return (
            <Step
              key={label}
              className={classes.step}
              onClick={() => handleHighRiskStep(index)}
              completed={index < activeStep}
            >
              <StepLabel
                StepIconComponent={Icon}
                onClick={() =>
                  setActiveStep(index <= activeStep ? index : activeStep)
                }
                style={{ cursor: index <= activeStep ? 'pointer' : '' }}
                className={classes.stepLabelText}
                optional={labelProps}
              >
                {label}
              </StepLabel>
            </Step>
          )
        })}
      </MuiStepper>
      <Grid className={classes.actionsContainer}>{children}</Grid>
    </Grid>
  )
}

export default HighRiskStepper
